exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-762dfab5] .el-card__body{height:100%}[data-v-762dfab5] .el-select{width:187px}", ""]);

// exports
